import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modalSection: {
    paddingTop: "1rem",
    width: "100%",
  },

  textEditorContainer: {
    position: "relative",
  },
  listSubHeader: {
    textTransform: "uppercase",
    color: "#9CA6AF !important",
    fontFamily: "Manrope !important",
    fontSize: "10px !important",
    lineHeight: "30px !important",
  },
}));

export default styles;
